'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const PricingOffer = renderWithRef('PricingOffer', null, (o, n)=>{
    let { children: t } = o;
    return jsx(RenderComp, {
        root: "span",
        forwardedRef: n,
        classNames: new Set([
            'swan-pricing-offer'
        ]),
        props: o,
        children: t
    });
});

export { PricingOffer };
